(function ($) {
  'use strict';

  var $self;


  /**
   * Main functionality should be in an 'init' function
   */
  var initTabbedArticles = function () {
    $self = $(this);
    var paneTitle = $('.pane-title', $self);

    var tabbedArticlesCarousel = new Swiper($('.swiper', $self)[0], {
      slidesPerGroup: 1,
      slidesPerView: 1,
      a11y: true,
      effect: 'fade',
      simulateTouch: false,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: $('.tabbed-articles-pagination', $self)[0],
        clickable: true,
        bulletClass: 'tabbed-articles-bullet',
        bulletActiveClass: 'active',
        renderBullet: function (index, className) {
          var title = paneTitle.eq(index).html();
          return (
            '<li class="' + className + '"><span class="side-nav-link">' + title + '</span></li>'
          )
        }
      },
      on: {
        init: function () {
          $('.swiper-slide:not(.swiper-slide-visible)', $self).attr('aria-hidden', true);
          $('.swiper-slide:not(.swiper-slide-visible)', $self).attr('tabindex', '-1');
          $('.swiper-slide:not(.swiper-slide-visible)', $self).find('a, button').attr({
            'aria-hidden': true,
            'tabindex': -1
          });
          $('.swiper-slide-visible', $self).attr('aria-hidden', false);
          $('.swiper-slide-visible', $self).attr('tabindex', '0');

          $('select', $self).on('change', function(e) {
            var index = this.options[e.target.selectedIndex].value;
            tabbedArticlesCarousel.slideTo(index);
          });
        },
        slideChangeTransitionEnd: function () {
          $('.swiper-slide:not(.swiper-slide-visible)', $self).attr('aria-hidden', true);
          $('.swiper-slide:not(.swiper-slide-visible)', $self).attr('tabindex', '-1');
          $('.swiper-slide:not(.swiper-slide-visible)', $self).find('a, button').attr({
            'aria-hidden': true,
            'tabindex': -1
          });
          $('.swiper-slide-visible', $self).attr('aria-hidden', false);
          $('.swiper-slide-visible', $self).attr('tabindex', '0');
          $('.swiper-slide-visible', $self).find('a, button').attr({
            'aria-hidden': false,
            'tabindex': 0
          });
        },
        slideChange: function (swiper) {
          $('select', $self).find('option').eq(swiper.activeIndex).attr('selected', true);
        }
      }
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.tabbedArticles = {
    attach: function (context) {
      $(context).find('.cc--tabbed-articles').once('tabbedArticles').each(function () {
        initTabbedArticles.apply(this);
      });
    }
  };

}(jQuery));
